export const REACT_APP_API_URL = 'https://api-au.criteriacorp.com/api/v1'; 
export const REACT_APP_AI_SERVICE_URL = 'https://aiservice-au.criteriacorp.com'; 
export const REACT_APP_ODA_URL = 'https://au.ondemandassessment.com/'; 
export const REACT_APP_URL = 'https://develop-au.criteriacorp.com/'; 
export const REACT_APP_HIRESELECT_URL = 'https://app-au.criteriacorp.com'; 
export const ENVIRONMENT: 'dev' | 'prod' | 'stg' | 'local' = 'prod'; 
export const REACT_APP_SEGMENT_KEY = 'k3rjVFuIRl6MK8emqtsPi7AK4fKfspzr'; 
export const CONFIG_CAT_APP_KEY = 'wmPYCHgfSk6BY6_oMK2s8w/HXNLpNCmnUONrIt5NgImRA'; 
export const IS_AU_INSTANCE = true; 
export const sskowk = 'n4Ws7sHmGQJ3w0GJ'; 
export const SENTRY_DSN = 'https://d3fb3e34604fd481cd195337cc77c3eb@o171476.ingest.us.sentry.io/4509645343817728'; 
